import ACTION_TYPES from '../../constants/actionTypes';
import clone from 'lodash/clone';
import get from 'lodash/get';
import map from 'lodash/map';
import merge from 'lodash/merge';
import reduce from 'lodash/reduce';

const reducers = {

  isFetchingPolicies(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS:
      case ACTION_TYPES.GET_POLICIES_FOR_VERTICAL:
      case ACTION_TYPES.GET_POLICY_BY_ID:
        return true;
      case ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS_SUCCESS:
      case ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS_FAILURE:
      case ACTION_TYPES.GET_POLICIES_FOR_VERTICAL_SUCCESS:
      case ACTION_TYPES.GET_POLICIES_FOR_VERTICAL_FAILURE:
      case ACTION_TYPES.GET_POLICY_BY_ID_SUCCESS:
      case ACTION_TYPES.GET_POLICY_BY_ID_FAILURE:
        return false;
      default:
        return state;
    }
  },

  policiesById(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS_SUCCESS:
        return reduce(action.payload, (result, policiesSummary) => {
          policiesSummary.items.forEach((item) => {
            if (!result[item.id]) {
              result[item.id] = merge(result[item.id] || {}, item);
            }
          });
          return result;
        }, clone(state));
      case ACTION_TYPES.GET_POLICIES_FOR_VERTICAL_SUCCESS:
        return reduce(action.payload.policies, (result, policy) => {
          result[policy.id] = merge(result[policy.id] || {}, policy);
          return result;
        }, clone(state));
      case ACTION_TYPES.GET_POLICY_BY_ID_SUCCESS:
        let newState = clone(state);
        newState[action.payload.policy.id] = action.payload.policy;
        return newState;
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  mostRecentPolicyIdsByVertical(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS_SUCCESS:
        return reduce(action.payload, (result, policiesSummary) => {
          if (policiesSummary.items.length) {
            result[policiesSummary.vertical_code] = map(policiesSummary.items, 'id');
          }
          return result;
        }, {});
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

  policiesTotalsByVertical(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_POLICIES_FOR_ALL_VERTICALS_SUCCESS:
        return reduce(action.payload, (result, policiesSummary) => {
          result[policiesSummary.vertical_code] = policiesSummary.total;
          return result;
        }, {});
      case ACTION_TYPES.GET_POLICIES_FOR_VERTICAL_SUCCESS:
        const verticalCode = get(action.payload, 'policies[0].vertical_code');
        return verticalCode ? {
          ...state,
          [verticalCode]: action.payload.policies.length,
        } : state;
      case ACTION_TYPES.SIGN_OUT:
        return {};
      default:
        return state;
    }
  },

};

export default reducers;
